export default "__VITE_ASSET__BHDteZkv__"